import { HAS_ACCESS,ADD_UID,CHANGE_LANGUAGE } from '../actions/action_types';
import {console_log} from "../utils/helper";

var initialState = {
    hasAccess: false,
    uid: '',
    token: '',
    currentLang : ''
};

export const WelcomeReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case HAS_ACCESS:
            return {
                ...state,
                hasAccess: action.data.success,
                uid: action.data.uid,
                token: action.data.token,
                subscriptionData: action.data.subscriptionData,
            };
        case ADD_UID:
            return {
                ...state,
                uid: action.data.uid
            };
        case CHANGE_LANGUAGE:
                return {
                    ...state,
                    currentLang: action.data
                };    
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/WelcomeReducer.js